import { render, staticRenderFns } from "./FormGrid.vue?vue&type=template&id=dafdc7c2&scoped=true&"
import script from "./FormGrid.vue?vue&type=script&lang=js&"
export * from "./FormGrid.vue?vue&type=script&lang=js&"
import style0 from "./FormGrid.vue?vue&type=style&index=0&id=dafdc7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafdc7c2",
  null
  
)

export default component.exports